module.exports = __webpack_public_path__ + "img/hospital.4594845f.png";